var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgColumns = function SvgColumns(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1V15M5 1H2.33333C1.97971 1 1.64057 1.16389 1.39052 1.45561C1.14048 1.74733 1 2.143 1 2.55556V13.4444C1 13.857 1.14048 14.2527 1.39052 14.5444C1.64057 14.8361 1.97971 15 2.33333 15H5M5 1C5 1 7.24264 1 9 1M5 15C5 15 7.24264 15 9 15M9 15C9.84614 15 11.6667 15 11.6667 15C12.0203 15 12.3594 14.8361 12.6095 14.5444C12.8595 14.2527 13 13.857 13 13.4444V2.55556C13 2.143 12.8595 1.74733 12.6095 1.45561C12.3594 1.16389 12.0203 1 11.6667 1C11.6667 1 9.84614 1 9 1M9 15V1",
    stroke: "#000A4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColumns, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/columns.df064aed.svg";
export { ForwardRef as ReactComponent };